import OrganizationsList from './OrganizationsList';

export default OrganizationsList;
